import { Col, Row } from "react-bootstrap"
import { useAppSelector } from "../../../../../stateManagement/hooks/redux"
import SmallLoader from "../../../../loaders/SmallLoader"
import { formatDate, thousandSeparator } from "../../../../../features/dataFormatFunctions/dataFormatter"
import { useParams } from "react-router-dom"
import { tableEnums } from "../../../tableFeatures/tableEnums"

const objects_icon = require('../../../../../assets/images/icons/objects_icon.png')
const road_icon = require('../../../../../assets/images/icons/road_icon.png')
const direction_icon = require('../../../../../assets/images/icons/direction_icon.png')
const found_results_icon = require('../../../../../assets/images/icons/found_results_icon.png')

export function DefectsInfoContent() {
    const { defectClassificator }: any = useParams();
    const { roadName, pathName } = useAppSelector(state => state.pathsInfo.selectedPath) ?? {}
    const caption = useAppSelector(state => state.table.caption)
    const dataCount = useAppSelector(state => state.table.dataCount)
    const currentRoadDiagnosticsSegment = useAppSelector(state => state.roadDiagnosticsSegments.currentRoadDiagnosticsSegment)
    let { Position, Ending } = currentRoadDiagnosticsSegment ?? {}
    if (typeof Position === 'number') Position = Position.toFixed(3)
    if (typeof Ending === 'number') Ending = Ending.toFixed(3)
    if (Position != null) Position = `${Position} км`;
    if (Ending != null) Ending = `${Ending} км`;
    const defectSegmentType = tableEnums['DefectClassificator']?.[defectClassificator]
    return (
        <>
            <h5 className="table-info-head">В таблице отображены:</h5>
            <Row>
                <Col xs={12} md={6} xl={4} className="col">
                    <p>
                        <img src={objects_icon} className="basic-image" /><strong>Объекты:</strong>
                        <span className="table-info-value"> {caption}</span>
                    </p>
                    <p>
                        <img src={road_icon} className="basic-image" /><strong>По дороге:</strong>
                        <span className="table-info-value"> {roadName ? roadName : <SmallLoader iconColor="black" />}</span>
                    </p>
                    <p>
                        <img src={direction_icon} className="basic-image" /><strong>Направление:</strong>
                        <span className="table-info-value"> {pathName ? pathName : <SmallLoader iconColor="black" />}</span>
                    </p>
                    <p>
                        <img src={found_results_icon} className="basic-image" /><strong>Найдено объектов:</strong>
                        <span className="table-info-value"> {dataCount != null ? dataCount : <SmallLoader iconColor="black" />}</span>
                    </p>
                </Col>
                <Col xs={12} md={6} xl={4} className="col">
                    <p>
                        <strong>Тип участка дефектов:</strong>
                        <span className="table-info-value"> {defectSegmentType ? defectSegmentType : 'не указано'}</span>
                    </p>
                    <p>
                        <strong>Начало участка:</strong>
                        <span className="table-info-value"> {Position != null ? Position : 'не указано'}</span>
                    </p>
                    <p>
                        <strong>Конец участка:</strong>
                        <span className="table-info-value"> {Ending != null ? Ending : 'не указано'}</span>
                    </p>
                </Col>
            </Row>
        </>
    )
}
